






























































import { Component, Mixins, Prop } from "vue-property-decorator";
import ClientMixin from "@/mixins/clientMixin";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-tags": () => import("@/components/app/global/client/clientTags.vue")
  }
})
export default class ClientWellLink extends Mixins(ClientMixin) {
  // Inject

  @Prop({ required: true })
  public readonly client!: IClient;

  // Computed

  public get clientName() {
    return this.getClientName({
      client: this.client,
      clientId: this.client?.id,
      orEmail: true
    });
  }

  public get clientTags() {
    return this.client?.tags || [];
  }

  public get showEmail() {
    const email = this.client?.email;
    return email && this.clientName !== email;
  }

  // Methods

  public copyToClipboard(text) {
    if (!text) return;
    this.$copyText(text).then(() => {
      this.$buefy.toast.open({
        message: this.$t("_.copied_to_clipboard") as string
      });
    });
  }
}
